export default __webpack_public_path__ + "static/media/Background_00225.a55c726f.png";